import React from 'react'
import PT from 'prop-types'
import Plyr from 'react-plyr'
import cx from 'classnames'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'
import { Grid, Row, Col } from 'react-bootstrap'
import { isEmpty } from 'ramda'
import ImageDetail from '../Images/ImagesDetail'
import AuthorInfo from './AuthorInfo'
import withPostDetail from '../../hoc/withPostDetail'
import { imagesProp } from '../../propTypes'
import './Post.css'
import './PostDetail.css'
import AudioPlayer from '../Audio/AudioPlayer'
import LikeBtn from './LikeBtn'
import { audioSrcFromProps, typeFromProps } from './helpers'

const PostDetail = (props) => {
  const is89 = props.location.pathname.startsWith('/89')
  const type = typeFromProps(props)
  const isTextOrAudio = type === 'Text' || type === 'Audio'
  const audioSrc = audioSrcFromProps(props, is89)
  const thisUrl = window.location.origin + props.location.pathname
  const detailLayout = isTextOrAudio
    ? { xs: 12, md: 8 }
    : {
      xs: 12, md: 6, mdPull: 6, lg: 4, lgPull: 8,
    }

  return (
    <Grid className="PostDetail">
      <Helmet>
        <title>{props.name} - SPÝTAJ SA VAŠICH 68</title>
      </Helmet>
      <Row>
        {props.id && (
          <Col className="youtube-container" xs={12} md={6} mdPush={6} lg={8} lgPush={4}>
            <Plyr type="youtube" className={`plyr${props.id}`} videoId={props.id} />
          </Col>
        )}

        {!props.id && !isEmpty(props.images) && (
          <Col className="images-container" xs={12} md={6} mdPush={6} lg={8} lgPush={4}>
            <ImageDetail images={props.images} />
          </Col>
        )}

        <Col {...detailLayout}>
          <div className={cx('detail-content', { 'text-audio': isTextOrAudio })}>
            {audioSrc && (
              <AudioPlayer
                resolveUrl={audioSrc}
                streamUrl={audioSrc}
                preloadType="metadata"
              />
            )}

            <AuthorInfo
              linkDetail={thisUrl}
              type={props.type}
              date={props.date}
              name={props.name}
            />
            <div className="text" dangerouslySetInnerHTML={{ __html: props.content }} />
            <LikeBtn to={thisUrl} />
          </div>
        </Col>
      </Row>
    </Grid>
  )
}


PostDetail.propTypes = PT.shape({
  id: PT.string.isRequired,
  type: PT.string.isRequired,
  date: PT.string.isRequired,
  name: PT.string.isRequired,
  content: PT.string.isRequired,
  images: imagesProp,
  location: PT.shape({
    pathname: PT.string.isRequired,
  }),
  files: PT.arrayOf(PT.string.isRequired),
}).isRequired

PostDetail.defaultProps = {
  images: [],
  files: [],
}

export default withPostDetail(withRouter(PostDetail))



// WEBPACK FOOTER //
// ./src/components/Post/PostDetail.js